var isArray = function isArray(value) {
  return Array.isArray(value);
};
export default isArray;